import api from './api';

const dashboardService = {
  async getKPIs(projectIdOrCode) {
    const params = {};
    if (projectIdOrCode != null && projectIdOrCode !== '') {
      const v = String(projectIdOrCode).trim();
      params[Number.isInteger(Number(v)) && v === String(Number(v)) ? 'projectId' : 'projectCode'] = v;
    }
    const response = await api.get('/dashboard/kpis', { params });
    return response.data;
  },

  async getActionSummary() {
    const response = await api.get('/dashboard/action-summary');
    return response.data;
  },

  async getEnrollmentTrend() {
    const response = await api.get('/dashboard/enrollment-trend');
    return response.data;
  },

  async getActionAging() {
    const response = await api.get('/dashboard/action-aging');
    return response.data;
  },

  async getStageCards(projectIdOrCode) {
    const params = {};
    if (projectIdOrCode != null && projectIdOrCode !== '') {
      const v = String(projectIdOrCode).trim();
      params[Number.isInteger(Number(v)) && v === String(Number(v)) ? 'projectId' : 'projectCode'] = v;
    }
    const response = await api.get('/dashboard/stage-cards', { params });
    return response.data;
  },
};

export default dashboardService;